const links = [
        {
            "url": "http://listofrandomnames.com/",
            "display": "List of Random Names",
            "alt": "This application generates endless unique first and last names quickly." 
        },
        {
            "url": "http://listofrandomwords.com/",
            "display": "List of Random Words",
            "alt": "Because typing random stuff is hard",
            "tagline": "Because typing random stuff is hard",
            "desc": "Generate a list, paragraph or table of random words"
        },
        {
            "url": "http://howmanydayssince.net/",
            "display": "How many days since?",
            "alt": "Quickly figure out how may days between now and some important date in the past"
        }
    ]

export default links;


// WEBPACK FOOTER //
// ./src/data/links.js